
export default function Summary() {
  const highlights = [
    { icon: "ri-time-line", text: "20 ans d'expérience" },
    { icon: "ri-pencil-ruler-2-line", text: "Conception sur mesure" },
    { icon: "ri-tools-line", text: "Fabrication moderne et durable" },
    { icon: "ri-hammer-line", text: "Installation professionnelle" },
    { icon: "ri-star-line", text: "Matériaux haute qualité" },
    { icon: "ri-home-gear-line", text: "Solutions pour intérieurs & extérieurs" },
    { icon: "ri-customer-service-2-line", text: "Service client réactif" }
  ];

  return (
    <section className="py-24 bg-[#1E3A5F] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#A83232] rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#A83232] rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Récapitulatif
          </h2>
          <div className="w-24 h-1 bg-[#A83232] mx-auto mb-8"></div>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Votre partenaire de confiance pour tous vos projets métalliques
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {highlights.map((item, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/20 transition-all duration-300"
            >
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#A83232] rounded-lg flex-shrink-0">
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <p className="text-white font-semibold text-lg">
                  {item.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a 
            href="#contact"
            className="inline-block bg-[#A83232] text-white px-10 py-4 rounded-lg font-semibold text-lg hover:bg-[#8A2828] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Démarrer votre projet
          </a>
        </div>
      </div>
    </section>
  );
}
